let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("2Y3CR")]).then(() => parcelRequire('1cQxv'));